import { render, staticRenderFns } from "./withdraw-user-config.vue?vue&type=template&id=a80fdd7c&scoped=true"
import script from "./withdraw-user-config.vue?vue&type=script&lang=js"
export * from "./withdraw-user-config.vue?vue&type=script&lang=js"
import style0 from "./withdraw-user-config.vue?vue&type=style&index=0&id=a80fdd7c&prod&scoped=true&lang=css"
import style1 from "./withdraw-user-config.vue?vue&type=style&index=1&id=a80fdd7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80fdd7c",
  null
  
)

export default component.exports